import styled from '@emotion/styled';
import { TextButton } from '../../components/Button/Button.styles';

const AnchorButton = TextButton.withComponent('a');

export const StyledAnchor = styled(AnchorButton)`
  text-decoration: none;
  margin: 0;
  padding: 0;
  display: inline;
`;
